<template>
  <client-only>
    <div :key="picUrl" v-lazy:background-image="{ src: picUrl }" :class="props.class" />
  </client-only>
</template>

<script setup lang="ts">
const props = defineProps<{
  id?: number
  thumb?: boolean
  class?: string | string[]
}>()

const user = useUser(props.id)

const picUrl = computed(() => {
  if (!user.value) {
    return '/images/placeholder/profile_photo.svg'
  }
  if (props.thumb && user.value.profile_photo_thumb_url) {
    return user.value.profile_photo_thumb_url
  } else if (user.value.profile_photo_large_url) {
    return user.value.profile_photo_large_url
  } else {
    return '/images/placeholder/profile_photo.svg'
  }
})
</script>

<style scoped>
div {
  display: inline-block;
  height: 40px;
  width: 40px;
  vertical-align: middle;
  background-color: #ccc;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
}
</style>
